import axios from "axios";
import axiosMock from "axios-mock-adapter";
import * as faker from 'faker';

const mock = new axiosMock(axios);

const docs = [];

const aspectRatios = [
    '4:3', '1.33:1', '16:9', '1.85:1', '2.39:1', '2.76:1', '1.37:1',
];

for (let i = 0; i < 10; i++) {
    let numberOfTags = faker.datatype.number({min: 1, max: 3});

    docs.push({
        _id: faker.datatype.number(),
        title: faker.lorem.words().split(' '),
        description: faker.lorem.paragraph(),
        uri: faker.internet.url(),
        uuid: faker.datatype.uuid(),
        aspectRatio: faker.random.arrayElement(aspectRatios),
        tags: faker.lorem.words(numberOfTags).split(' '),
    });
}

mock.onGet(`${process.env.VUE_APP_SERVICE_URI_VIDEO}/api/vimeo-youtube`, { params: {
        page: 1,
    }}).reply(200, {
    docs: docs,
});